import { useQuery } from "@tanstack/react-query";
import { QueryBuilder } from "features/members";
import { axios } from "lib/axios";

export const getRequisitionsPaginated = ({
  churchId,
  page,
  pageSize,
  queries
}) => {
  const queryBuilder = new QueryBuilder();

  queryBuilder.pagination(page, pageSize);

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  if (queries.filter) {
    queryBuilder.filter(queries.filter);
  }

  const queryString = queryBuilder.build();

  return axios.get(
    `/churches/${churchId}/requisitions-paginated${queryString}`
  );
};

export const useRequisitionsPaginated = ({
  churchId,
  page,
  pageSize,
  queries = {},
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "requisitions-paginated",
      churchId,
      page,
      pageSize,
      JSON.stringify(queries)
    ],
    queryFn: () =>
      getRequisitionsPaginated({ churchId, page, pageSize, queries })
  });
};
